let date1970 = [];
let cache = [];
let cacheYear = [];
let cacheCountry = [];
let dataByCountry = {};
let counter = 0;
let slickSlider = false;

//Base data format
let objectsVar = [{
    name: 'Europe',
    data: [{
        name: 'Germany',
        code: 'DEU',
        value: 767.1
    }, {
      name: 'Croatia',
      code: 'HRV',
      value: 20.7
    },
    {
      name: "Belgium",
      code: 'BEL',
      value: 97.2
    },
    {
      name: "Czech Republic",
      code: 'CZE',
      value: 111.7
    },
    {
      name: "Netherlands",
      code: 'NLD',
      value: 158.1
    },
    {
      name: "Spain",
      code: 'ESP_AND',
      value: 241.6
    },
    {
      name: "Ukraine",
      code: 'UKR',
      value: 249.1
    },
    {
      name: "Poland",
      code: 'POL',
      value: 298.1
    },
    {
      name: "France",
      code: 'FRA_MCO',
      value: 323.7
    },
    {
      name: "Romania",
      code: 'ROU',
      value: 78.3
    },
    {
      name: "United Kingdom",
      code: 'GBR',
      value: 415.4
    }, {
      name: "Turkey",
      code: 'TUR',
      value: 353.2
    }, {
      name: "Italy",
      code: 'ITA_SMR_VAT',
      value: 337.6
    },
    {
      name: "Greece",
      code: 'GRC',
      value: 71.1
    },
    {
      name: "Austria",
      code: 'AUS',
      value: 69.8
    },
    {
      name: "Belarus",
      code: 'BLR',
      value: 67.7
    },
    {
      name: "Serbia",
      code: 'SRB_MNE',
      value: 59.3
    },
    {
      name: "Finland",
      code: 'FIN',
      value: 54.8
    },
    {
      name: "Bulgaria",
      code: 'BGR',
      value: 51.2
    },
    {
      name: "Portugal",
      code: 'PRT',
      value: 48.3
    },
    {
      name: "Norway",
      code: 'NOR',
      value: 44.4
    },
    {
      name: "Sweden",
      code: 'SWE',
      value: 44.3
    },
    {
      name: "Hungary",
      code: 'HUN',
      value: 43.7
    },
    {
      name: "Switzerland",
      code: 'CHE_LIE',
      value: 40.2
    },
    {
      name: "Denmark",
      code: 'DNK',
      value: 40
    },
    {
      name: "Slovakia",
      code: 'SVK',
      value: 34.7
    },
    {
      name: "Ireland",
      code: 'IRL',
      value: 34.6
    },
    {
      name: "Estonia",
      code: 'EST',
      value: 19.4
    },
    {
      name: "Slovenia",
      code: 'SVN',
      value: 16.7
    },
    {
      name: "Lithuania",
      code: 'LTU',
      value: 12.3
    },
    {
      name: "Luxembourg",
      code: 'LUX',
      value: 10.4
    },
    {
      name: "Macedonia",
      code: 'GE',
      value: 9.5
    },
    {
      name: "Moldova",
      code: 'MKD',
      value: 7.8
    },
    {
      name: "Latvia",
      code: 'LVA',
      value: 7.5
    },
    {
      name: "Cyprus",
      code: 'CYP',
      value: 7.2
    }]
  }, {
    name: 'Africa',
    data: [{
      name: "Senegal",
      code: 'SEN',
      value: 8.2
    },
    {
      name: "Cameroon",
      code: 'CMR',
      value: 9.2
    },
    {
      name: "Zimbabwe",
      code: 'ZWE',
      value: 13.1
    },
    {
      name: "Ghana",
      code: 'GHA',
      value: 14.1
    },
    {
      name: "Kenya",
      code: 'KEN',
      value: 14.1
    },
    {
      name: "Sudan",
      code: 'SDN_SSD',
      value: 17.3
    },
    {
      name: "Tunisia",
      code: 'TUN',
      value: 24.3
    },
    {
      name: "Angola",
      code: 'AGO',
      value: 25
    },
    {
      name: "Libya",
      code: 'LBY',
      value: 50.6
    },
    {
      name: "Ivory Coast",
      code: 'CIV',
      value: 7.3
    },
    {
      name: "Morocco",
      code: 'MAR',
      value: 60.7
    },
    {
      name: "Ethiopia",
      code: 'ETH',
      value: 8.9
    },
    {
      name: "United Republic of Tanzania",
      code: 'TZA',
      value: 9.1
    },
    {
      name: "Nigeria",
      code: 'NGA',
      value: 93.9
    },
    {
      name: "South Africa",
      code: 'ZAF',
      value: 392.7
    }, {
      name: "Egypt",
      code: 'EGY',
      value: 225.1
    }, {
      name: "Algeria",
      code: 'DZA',
      value: 141.5
    }]
  }, {
    name: 'Oceania',
    data: [{
      name: "Australia",
      code: 'AUS',
      value: 409.4
    },
    {
      name: "New Zealand",
      code: 'NZL',
      value: 34.1
    },
    {
      name: "Papua New Guinea",
      code: 'PNG',
      value: 7.1
    }]
  }, {
    name: 'North America',
    data: [{
      name: "Costa Rica",
      code: 'CRI',
      value: 7.6
    },
    {
      name: "Honduras",
      code: 'HND',
      value: 8.4
    },
    {
      name: "Jamaica",
      code: 'JAM',
      value: 8.3
    },
    {
      name: "Panama",
      code: 'PAN',
      value: 10.2
    },
    {
      name: "Guatemala",
      code: 'GTM',
      value: 12
    },
    {
      name: "Dominican Republic",
      code: 'DOM',
      value: 23.4
    },
    {
      name: "Cuba",
      code: 'CUB',
      value: 30.2
    },
    {
      name: "USA",
      code: 'USA',
      value: 5334.5
    }, {
      name: "Canada",
      code: 'CAN',
      value: 566
    }, {
      name: "Mexico",
      code: 'MEX',
      value: 456.3
    }]
  }, {
    name: 'South America',
    data: [{
      name: "El Salvador",
      code: 'SLV',
      value: 7.2
    },
    {
      name: "Uruguay",
      code: 'URY',
      value: 8.1
    },
    {
      name: "Bolivia",
      code: 'BOL',
      value: 17.8
    },
    {
      name: "Trinidad and Tobago",
      code: 'TTO',
      value: 34
    },
    {
      name: "Ecuador",
      code: 'ECU',
      value: 43
    },
    {
      name: "Chile",
      code: 'CHL',
      value: 78.6
    },
    {
      name: "Peru",
      code: 'PER',
      value: 52
    },
    {
      name: "Colombia",
      code: 'COL',
      value: 74.1
    },
    {
      name: "Brazil",
      code: 'BRA',
      value: 501.1
    }, {
      name: "Argentina",
      code: 'ARG',
      value: 199
    },
    {
      name: "Venezuela",
      code: 'VEN',
      value: 195.2
    }]
  }, {
    name: 'Asia',
    data: [{
      name: "Nepal",
      code: 'NPL',
      value: 6.5
    },
    {
      name: "Georgia",
      code: 'GEO',
      value: 6.5
    },
    {
      name: "Brunei Darussalam",
      code: 'BRN',
      value: 7.4
    },
    {
      name: "Kyrgyzstan",
      code: 'KGZ',
      value: 7.4
    },
    {
      name: "Afghanistan",
      code: 'AFG',
      value: 7.9
    },
    {
      name: "Myanmar",
      code: 'MMR',
      value: 9.1
    },
    {
      name: "Mongolia",
      code: 'MNG',
      value: 14.7
    },
    {
      name: "Sri Lanka",
      code: 'LKA',
      value: 16.6
    },
    {
      name: "Bahrain",
      code: 'BHR',
      value: 20.5
    },
    {
      name: "Yemen",
      code: 'YEM',
      value: 22.6
    },
    {
      name: "Jordan",
      code: 'JOR',
      value: 22.3
    },
    {
      name: "Lebanon",
      code: 'LBN',
      value: 21.1
    },
    {
      name: "Azerbaijan",
      code: 'AZE',
      value: 31.7
    },
    {
      name: "Singapore",
      code: 'SGP',
      value: 47.8
    },
    {
      name: "Hong Kong",
      code: 'HKG',
      value: 49.9
    },
    {
      name: "Syria",
      code: 'SYR',
      value: 52.7
    },
    {
      name: "DPR Korea",
      code: 'PRK',
      value: 59.9
    },
    {
      name: "Israel",
      code: 'ISR_PSE',
      value: 64.8
    },
    {
      name: "Turkmenistan",
      code: 'TKM',
      value: 70.6
    },
    {
      name: "Oman",
      code: 'OMN',
      value: 74.3
    },
    {
      name: "Qatar",
      code: 'QAT',
      value: 88.8
    },
    {
      name: "Philippines",
      code: 'PHL',
      value: 96.9
    },
    {
      name: "Kuwait",
      code: 'KWT',
      value: 98.6
    },
    {
      name: "Uzbekistan",
      code: 'UZB',
      value: 122.6
    },
    {
      name: "Iraq",
      code: 'IRQ',
      value: 139.9
    },
    {
      name: "Pakistan",
      code: 'PAK',
      value: 158.1
    },
    {
      name: "Vietnam",
      code: 'VNM',
      value: 190.2
    },
    {
      name: "United Arab Emirates",
      code: 'ARE',
      value: 201.1
    },
    {
      name: "Malaysia",
      code: 'MYS',
      value: 227.5
    },
    {
      name: "Kazakhstan",
      code: 'KAZ',
      value: 236.2
    },
    {
      name: "Thailand",
      code: 'THA',
      value: 272
    },
    {
      name: "Taiwan",
      code: 'TWN',
      value: 276.7
    },
    {
      name: "Indonesia",
      code: 'IDN',
      value: 453
    },
    {
      name: "Saudi Arabia",
      code: 'SAU',
      value: 494.8
    },
    {
      name: "Japan",
      code: 'JPN',
      value: 1278.9
    },
    {
      name: "China",
      code: 'CHN',
      value: 10540.8
    },
    {
      name: "India",
      code: 'IND',
      value: 2341.9
    },
    {
      name: "Russia",
      code: 'RUS',
      value: 1766.4
    },
    {
      name: "Iran",
      code: 'IRN',
      value: 618.2
    },
    {
      name: "Korea",
      code: 'KOR',
      value: 610.1
    }]
  }];

/* --- Charts by Highcharts.com --- */
var chart = Highcharts.chart('bubbleChart', {
    chart: {
        type: 'packedbubble',
        height: '600px' 
    },
    title: {
        text: 'Carbon emissions around the world (2014)'
    },
    credits: {
        enabled: false
    },
    tooltip: {
        useHTML: true,
        pointFormat: '<b>{point.name}:</b> {point.y}m CO<sub>2</sub>'
    },
    plotOptions: {
        packedbubble: {
            minSize: '50%',
            maxSize: '300%',
            layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.01
            },
            dataLabels: {
                enabled: true,
                formatter: function () {
                    if($(window).width() > 1050)
                        return '<span style="font-size:13px">' + verifyCode(this.point.options.code) + '</span>';
                    if($(window).width() <= 1050)
                        return '<span style="font-size:9px">' + verifyCode(this.point.options.code) + '</span>';
                },
                style: {
                    color: 'rgb(40,40,40)',
                    textOutline: 'none',
                    fontWeight: 'normal'
                },
            },
            events: {
                click: function (event) {
                    counter++;
                    getInformations(this.chart.hoverPoint.options.code, counter);
                }
            },
            cursor:'pointer'
        }
    },
    series: objectsVar,
    exporting: {
        enabled: false
    }
});

var chartPie = Highcharts.chart('chartPie', {

    title: {
        text: 'Pie point CSS'
    },

    credits: {
        enabled: false
    },
    
    exporting: {
        enabled: false
    },
    
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false
        },
        cursor:'pointer'
      }
    },
    
    tooltip: {
      pointFormat: '{point.percentage:.1f}%'
    },
    
    legend: {
        enabled: true
    },

    series: [{
        type: 'pie',
        allowPointSelect: true,
        keys: ['name', 'y', 'selected', 'sliced'],
        data: [
            ['Transport', 29.9, false],
            ['Buildings', 71.5, false],
            ['Non-combustion', 106.4, false],
            ['Power Industry', 129.2, false],
            ['Other industrial combustion', 144.0, true, true]
        ],
        showInLegend: true
    }]
});

var chartPie2 = Highcharts.chart('chartPie2', {

    title: {
        text: 'Pie point CSS'
    },

    credits: {
        enabled: false
    },
    
    exporting: {
        enabled: false
    },
    
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false
        },
          
        cursor:'pointer'
      }
    },
    
    tooltip: {
      pointFormat: '{point.percentage:.1f}%'
    },
    
    legend: {
        enabled: true
    },

    series: [{
        type: 'pie',
        allowPointSelect: true,
        keys: ['name', 'y', 'selected', 'sliced'],
        data: [
            ['Transport', 29.9, false],
            ['Buildings', 71.5, false],
            ['Non-combustion', 106.4, false],
            ['Power Industry', 129.2, false],
            ['Other industrial combustion', 144.0, true, true]
        ],
        showInLegend: true
    }]
});

/* --- Typed function by Typed.js --- */
var typed = new Typed('#typed',{
    stringsElement: '#typed-strings',
    typeSpeed: 150,
    loop: false,
    startDelay: 750,
    showCursor:false
});

/* --- Document ready and resize --- */
$(document).ready(function(){
    let hash = window.location.hash;

    //Initialize functions
    tipsSlider();
    getData();
    
    //On load get # pagination
    if($(window).width() > 1050){
        if(!hash)
            hash = '#Home';
        
        scrollSmooth(hash);
        
        chart.setSize(null, '100%');
    }else{
        hash = hash.slice(1);
        if(hash)
            $('body').attr('data-page', hash);
        
        tipsSlider();
    }
    
    //close btn comp
    $('#btn1').click(function(e){
        counter = 0;
        $('.chart__pie--1').fadeOut().hide();
        
        if($('.chart__pie--2').is(':hidden')){
            $('body').attr('data-comp', 'false');
            chart.reflow();
        }

    });

    //close btn comp
    $('#btn2').click(function(e){
        $('.chart__pie--2').fadeOut().hide();
        
        if($('.chart__pie--1').is(':visible')){
            counter = 1;
        }else{
            $('body').attr('data-comp', 'false');
            chart.reflow();
            counter = 0;
        }
    });
    
    //Get value from range and inject it in the packed bubble graph
    $('#myRange').on('input', function(e){
        var $this = $(this);

        clearTimeout($this.data('timeout'));
        $('#spanRange').html($this.val());

        $this.data('timeout', setTimeout(function(){
            filterData($this.val());
        }, 250));

    });
    
    //Animation burger
    $('.nav__burger').click(function(){
        let body = $('body');

        if(body.hasClass('menu--open')){
            body.removeClass('menu--open');
            body.addClass('menu--close');
        }else{
            if(body.hasClass('menu--close'))
                body.removeClass('menu--close');
            body.addClass('menu--open');
        }
    });

    //Header arrow click
    $('.header__arrow').click(function(){
        $('body').attr('data-page', "Informations");

        if($(window).width() >= 1200){
            scrollSmooth('#Informations');
        }
    });
    
});

$(window).resize(function(){
    let hash = window.location.hash;
    
    if($(window).width() > 1050){
        
        if(!hash)
            hash = '#Home';
        
        scrollSmooth(hash);
        
        if($('.chart__pie--1').is(':visible')){
            $('body').attr('data-comp', 'true');
            $('.chart__pie--1').css('display', 'flex');
        }
        if($('.chart__pie--2').is(':visible')){
            $('body').attr('data-comp', 'true');
            $('.chart__pie--2').css('display', 'flex');
        }
        
        chart.setSize(null, '100%');
    }
    
    if($(window).width() < 1050){
        hash = hash.slice(1);
        if(hash)
            $('body').attr('data-page', hash);
        
        $('body').attr('data-comp', 'false');
        
        if($('.chart__pie--1').is(':visible')){
            $('.chart__pie--1').css('display', 'block');
        }
        if($('.chart__pie--2').is(':visible')){
            $('.chart__pie--2').css('display', 'block');
        }
        
        chart.setSize(null, '600');
    }
    
    chart.reflow();
    chartPie2.reflow();
    chartPie.reflow();
    tipsSlider();
});

/* --- Get data from csv github --- */
function getData() {
    $.get("https://www.jeanchristophewieme.be/projets/data-play/json/openclimatedata.php",{query:"https://raw.githubusercontent.com/openclimatedata/edgar-co2-emissions/master/data/edgar-co2-emissions.csv"},
          function(data){
            cache = $.csv.toObjects(data);
            filterData(1970);
    });
    
}; 

/* --- Filters --- */

/* --- First check by Year --- */
function filterData(year){
    $('body').attr('data-state', 'loaded');
    cacheYear = [];
    cacheYear.push(cache.filter((value) => {return value.Year == year}));
    filterCountry(year);
};

/* --- Global variable by country --- */
function filterCountry(year){
    dataByCountry = new Object;
    
    $.each(cacheYear,function(i ,dataglobal){
        $.each(dataglobal, function(j, countryData){
            if (!dataByCountry[countryData.Code]){
                dataByCountry[countryData.Code]=0;
            }
            dataByCountry[countryData.Code] += parseFloat(countryData.Emissions);
        });
    });
    
    refreshData(year);
};

/* --- Inject in the bubble chart --- */
function refreshData(year){
    $.each(chart.series, function(i, continent){
        $.each(continent.data, function(j, country){
            let alphacode = country.code;
            country.update({value: Math.round(dataByCountry[alphacode])}, false);
            
            alphacode = verifyCode(country.code);
        })
    })
    chart.redraw();
    chart.setTitle({text: `Carbon emissions <br> around the world (${year})`});
};

/* --- Get data from a specific country into the pie chart --- */
function getInformations(code, count){
    let cacheCode = code;
    let cacheCountryInfo = [];
    let name;
    
    code = verifyCode(code);
    
    if($(window).width() > 1050){
        $('body').attr('data-comp', 'true');
    }else{
        $('body').attr('data-comp', 'false');
    }
    
    $.getJSON('https://restcountries.eu/rest/v2/alpha/' + code, function(json){
        cacheCountryInfo = json;
        
        let cacheCountryID = []; 
        let getYear = $('#myRange').val();   

        cacheCountryID.push(cacheYear[0].filter((value) => {return value.Code == cacheCode}));

        if(count == 1){
            $.each(cacheCountryID[0], function(i, element){
                name = element.Name;
                $.each(chartPie.series[0].points, function(j, elementChart){
                    if(elementChart.options.name === element.Sector){
                        elementChart.update({y: Math.round(element.Emissions)});
                    }
                })
            });

            let carbon = parseInt(dataByCountry[cacheCode]) * 1000 * 1000;
            let carbonperpeople = Math.round(carbon / parseInt(cacheCountryInfo.population));
            let tree = carbon/25;
            
            $('#flag1').html(`<img src="${cacheCountryInfo.flag}" alt="${cacheCountryInfo.name}" class="flag">`);
            $('#sup1').text(numberWithSpaces(cacheCountryInfo.area));
            $('#pop1').text(numberWithSpaces(cacheCountryInfo.population));
            $('#carbon1').text(numberWithSpaces(carbonperpeople));
            $('#tree1').text(numberWithSpaces(tree));

            chartPie.redraw();
            chartPie.setTitle({text: `Carbon emissions in <br>${name} (${getYear})`});
            
            if($(window).width() > 1050)
                $('.chart__pie--1').fadeIn().css("display", "flex");
            if($(window).width() < 1050)
                $('.chart__pie--1').fadeIn().css("display", "block");
            
            chartPie.reflow();
        }

        if(count >= 2){
            $.each(cacheCountryID[0], function(i, element){
                name = element.Name;
                $.each(chartPie2.series[0].points, function(j, elementChart){
                    if(elementChart.options.name === element.Sector){
                        elementChart.update({y: Math.round(element.Emissions)});
                    }
                })
            });
            
            let carbon = parseInt(dataByCountry[cacheCode]) * 1000 * 1000;
            let carbonperpeople = Math.round(carbon / parseInt(cacheCountryInfo.population));
            let tree = carbon/25;
            
            $('#flag2').html(`<img src="${cacheCountryInfo.flag}" alt="${cacheCountryInfo.name}" class="flag">`);
            $('#sup2').text(numberWithSpaces(cacheCountryInfo.area));
            $('#pop2').text(numberWithSpaces(cacheCountryInfo.population));
            $('#carbon2').text(numberWithSpaces(carbonperpeople));
            $('#tree2').text(numberWithSpaces(tree));

            chartPie2.redraw();
            chartPie2.setTitle({text: `Carbon emissions in <br>${name} (${getYear})`});
            
            if($(window).width() > 1050)
                $('.chart__pie--2').fadeIn().css("display", "flex");
            if($(window).width() < 1050)
                $('.chart__pie--2').fadeIn().css("display", "block");
            
            chartPie.reflow();
            chartPie2.reflow();
        }
    });
    
    chart.reflow();
    
};

/* --- Little conversion for Alpha Code --- */
function verifyCode(code){
    code === 'FRA_MCO' ? code='FRA' : code;
    code === 'ITA_SMR_VAT' ? code='ITA' : code;
    code === 'ESP_AND' ? code='ESP' : code;
    code === 'SRB_MNE' ? code='SRB' : code;
    code === 'CHE_LIE' ? code='CHE' : code;
    code === 'SDN_SSD' ? code='SDN' : code;
    code === 'ISR_PSE' ? code='ISR' : code;
    
    return code;
}

/* --- Delete . in numbers --- */
function numberWithSpaces(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
}

/* --- SmoothScroll Jquery --- */
function scrollSmooth(page){
    var speed = 750; // Durée de l'animation (en ms)
    $('html, body').animate( { scrollTop: $(page).offset().top }, speed ); // Go
    return false;
}

/* --- Bullet nav change with scroll --- */
$(window).on('scroll', function() {
    let anchors = $('.nav__el a');
    
    $.each(anchors, function(i, element){
        if(anchors[i+1] !== undefined){
             if($(window).scrollTop() >= ($(element.hash).offset().top - 50) && 
              $(window).scrollTop() <= ($(anchors[i+1].hash).offset().top + 50)){
                $('.active').removeClass('active');
                $(`a[href="${element.hash}"]`).addClass('active');
            }
        }
    });
});

/* --- Tips slider initialization --- */
function tipsSlider(){    
    if($(window).width() <= 1050){
        if(!slickSlider){
            $('.list').slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                adaptiveHeight: true,
                centerMode: true
            });
            slickSlider = true;
        }
    } else if($(window).width() > 1050){
        if(slickSlider){
            $('.list').slick('unslick');
            slickSlider = false;
        }
    }
};

/* --- Navigation function --- */
$('.nav__el a').click(function(e){
    if($(window).width() > 1050){
        $('.active').removeClass('active');
        $(this).addClass('active');

        scrollSmooth(e.currentTarget.hash);
    }
    
    if($(window).width() <= 1050){
        let pageNumber = $(this).attr('href');
        pageNumber = pageNumber.slice(1);
               
        $('body').attr('data-page', pageNumber);
        let body = $('body');

        if(body.hasClass('menu--open')){
            body.removeClass('menu--open');
            body.addClass('menu--close');
        }else{
            if(body.hasClass('menu--close'))
                body.removeClass('menu--close');
            body.addClass('menu--open');
        }
        $('.list').slick('setPosition');    
        chart.reflow();
    }
});
